class SlideShow {
    constructor($slide_section){
        const $slide_el = $slide_section
        const $trgs = $slide_section.querySelector(".slideshow__trgs");
        const $slide_trg = $slide_section.querySelectorAll(".slideshow__trgs__each");
        const $slide = $slide_section.querySelectorAll(".slideshow__each");
        let slides_length = $slide.length
        let current_index = 0;
        let is_animating = false;
        let duration_var = window
            .getComputedStyle($slide_el)
            .getPropertyValue("--duration");
        let duration = parseFloat(duration_var) * 1000;

        $slide_trg[current_index].classList.add("trg-slide-active");
        $slide[current_index].classList.add("slide-active");

        function trgClicked(inverse) {
            $slide_trg.forEach((el) => el.classList.remove("trg-slide-active"));
            $slide.forEach((el) => {
                el.classList.remove("from-left");
                if (el.classList.contains("slide-active")) {
                    el.classList.remove("slide-active");
                    el.classList.add("slide-current");
                    if (inverse) {
                        el.classList.add("to-right");
                    }
                    let myTimeout_Removeclass = setTimeout(function () {
                        el.classList.remove("slide-current");

                        if (inverse) {
                            el.classList.remove("to-right", "from-left");
                        }
                    }, duration);
                    let myTimeout_reset = setTimeout(function () {
                        is_animating = false;
                        clearTimeout(myTimeout_Removeclass);
                        clearTimeout(myTimeout_reset);
                    }, duration * 1.6);
                }
            });

            if (inverse) {
                $slide[current_index].classList.add("from-left");
            }
            $slide_trg[current_index].classList.add("trg-slide-active");
            let myTimeout_Removeclass = setTimeout(function () {
                $slide[current_index].classList.add("slide-active");
            }, 1);

        }

        $slide_trg.forEach((el) => {
            el.addEventListener("click", () => {
                if (is_animating) return;
                is_animating = true;
                let thisIndex = [].indexOf.call($slide_trg, el);
                if (thisIndex > current_index) {
                    current_index = thisIndex;
                    trgClicked(null);
                } else {
                    current_index = thisIndex;
                    trgClicked(true);
                }
            });
        });











        //? - =========================  TOUCH EVENTS  ========================= -//
        //? - =========================  TOUCH EVENTS  ========================= -//

        $slide_el.addEventListener('touchstart', handleTouchStart, false);
        $slide_el.addEventListener('touchmove', handleTouchMove, false);

        var xDown = null;
        var yDown = null;

        function handleTouchStart(evt) {
            xDown = evt.touches[0].clientX;
            yDown = evt.touches[0].clientY;
        };


        function handleTouchMove(evt) {
            if (!xDown || !yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                if (xDiff > 0) {
                    if (is_animating) return;
                    if (current_index > slides_length - 2) { current_index = - 1 }
                    $slide_trg[current_index + 1].dispatchEvent(new Event('click'));
                } else {
                    if (is_animating) return;
                    if (current_index == 0) { current_index = slides_length }
                    $slide_trg[current_index - 1].dispatchEvent(new Event('click'));
                }
            }
            /* reset values */
            xDown = null;
            yDown = null;
        };
    }
}


const $slides = document.querySelectorAll('.slideshow') || null 
if($slides.length > 0) {
    $slides.forEach(el => {
        new SlideShow(el)
    })
}